import React, { useEffect, useState } from "react";
import {
	InputAltitudeUnit,
	InputDistanceUnit,
	InputSpeedUnit,
	InputVolumeUnit,
} from "../../Helpers/Input/Input";
import trans from "../../../utils";
import { Select, Space } from "antd";
import { currencies } from "../../../utils/Currencies/Currencies";
import { InputSelect } from "../../Helpers/Input/RefactoredInput";
import axios from "axios";

export default function UserPreferences({ addData }) {
	const [timezones, setTimeZone] = useState([]);
	const getTimeZones = async () => {
		await axios
			.get(`${process.env.REACT_APP_API_URL}/server/timezones`, {
				headers: {
					Authorization: `Bearer ${localStorage.getItem("token")}`,
				},
			})
			.then((data) => {
				setTimeZone(
					data?.data?.map((i) => {
						return { label: i, value: i };
					}),
				);
			})
			.catch((err) => console.log("Err", err));
	};
	useEffect(() => {
		getTimeZones();
	}, []);
	return (
		<div className="userinfo mb-24">
			<p className="fs-16 fw-700 brand-700 text-uppercase">
				{trans("user preferences")}
			</p>
			<div className="row">
				<div className="col-lg-6">
					<InputSpeedUnit
						formstyle="form-input"
						id="attributes.speedUnit"
						name="attributes.speedUnit"
						onBlur={() => addData.setFieldTouched("attributes.speedUnit", true)}
						onChange={(value) =>
							addData.setFieldValue("attributes.speedUnit", value ? value : "")
						}
						value={addData.values.attributes.speedUnit || ""}
					/>
				</div>
				<div className="col-lg-6">
					<InputDistanceUnit
						formstyle="form-input"
						id="attributes.distanceUnit"
						name="attributes.distanceUnit"
						onBlur={() =>
							addData.setFieldTouched("attributes.distanceUnit", true)
						}
						onChange={(value) =>
							addData.setFieldValue(
								"attributes.distanceUnit",
								value ? value : "",
							)
						}
						value={addData.values.attributes.distanceUnit || ""}
					/>
				</div>
				<div className="col-lg-6">
					<InputAltitudeUnit
						formstyle="form-input"
						id="attributes.altitudeUnit"
						name="attributes.altitudeUnit"
						onBlur={() =>
							addData.setFieldTouched("attributes.altitudeUnit", true)
						}
						onChange={(value) =>
							addData.setFieldValue(
								"attributes.altitudeUnit",
								value ? value : "",
							)
						}
						value={addData.values.attributes.altitudeUnit || ""}
					/>
				</div>
				<div className="col-lg-6">
					<InputVolumeUnit
						formstyle="form-input"
						id="attributes.volumeUnit"
						name="attributes.volumeUnit"
						onBlur={() =>
							addData.setFieldTouched("attributes.volumeUnit", true)
						}
						onChange={(value) =>
							addData.setFieldValue("attributes.volumeUnit", value ? value : "")
						}
						value={addData.values.attributes.volumeUnit || ""}
					/>
				</div>
				<div className="col-lg-6">
					<InputSelect
						label="currency"
						options={currencies}
						onBlur={() => addData.setFieldTouched("attributes.currency", true)}
						onChange={(value) =>
							addData.setFieldValue("attributes.currency", value ? value : "")
						}
						allowClear={false}
						value={addData.values.attributes.currency || ""}
					/>
				</div>
				<div className="col-lg-6">
					<InputSelect
						label="timezone"
						placeholder={trans("Select Timezone")}
						options={[
							{ label: trans("Egypt"), value: "EG_UTC+3" },
							{ label: trans("Saudi Arabia"), value: "SA_UTC+3" },
							{ label: trans("United Arab Emirates"), value: "AE_UTC+4" },
							{ label: trans("Qatar"), value: "QA_UTC+3" },
							{ label: trans("Kenya"), value: "Africa/Nairobi" },
						]}
						onBlur={() => addData.setFieldTouched("attributes.timezone", true)}
						onChange={(value) =>
							addData.setFieldValue("attributes.timezone", value ? value : "")
						}
						value={addData.values.attributes.timezone || undefined}
					/>
				</div>
			</div>
		</div>
	);
}
